import { render, staticRenderFns } from "./permiss.vue?vue&type=template&id=20e2925a&scoped=true"
import script from "./permiss.vue?vue&type=script&lang=js"
export * from "./permiss.vue?vue&type=script&lang=js"
import style0 from "./permiss.vue?vue&type=style&index=0&id=20e2925a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2925a",
  null
  
)

export default component.exports